export default "__VITE_ASSET__C8NId1ID__"